import { AuthRoute } from "src/modules/auth/auth.routes";
import { CompanyProfileRoute } from "src/modules/companyProfile/companyProfile.routes";
import { InvoiceRoute } from "src/modules/invoices/invoices.routes";
import { QuickPayRoute } from "src/modules/quickPay/quickPay.routes";
import { SchedulingRoute } from "src/modules/scheduling/scheduling.routes";
import { SupplyPartnersRoute } from "src/modules/supplyPartners/supplyPartners.routes";
import { WorkOrderRoute } from "src/modules/work-order/workorder.routes";

export const ROUTES = [
  AuthRoute,
  WorkOrderRoute,
  InvoiceRoute,
  SchedulingRoute,
  QuickPayRoute,
  SupplyPartnersRoute,
  CompanyProfileRoute,
];
